<template>
  <filter-bar>
    <div class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100">
      <md-field>
        <label for="dateFrom">
          <md-icon>calendar_today</md-icon>
          <span v-show="!value.dateFrom">Desde</span>
        </label>
        <datetime
          input-style="border: none; outline:none; width: 100%"
          type="date"
          title="Desde"
          value-zone="America/Mexico_City"
          v-model="value.dateFrom"
          :phrases="{ ok: '', cancel: '' }"
          auto
        ></datetime>
        <md-button class="md-simple md-just-icon" @click="value.dateFrom = null">
          <md-icon>close</md-icon>
        </md-button>
      </md-field>
    </div>
    <div class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100">
      <md-field>
        <label for="dateOccurred">
          <md-icon>calendar_today</md-icon>
          {{ value.dateTo ? "" : "Hasta" }}
        </label>
        <datetime
          input-style="border: none; outline:none; width: 100%"
          type="date"
          title="Hasta"
          value-zone="America/Mexico_City"
          v-model="value.dateTo"
          :phrases="{ ok: '', cancel: '' }"
          auto
        ></datetime>
        <md-button class="md-simple md-just-icon" @click="value.dateTo = null">
          <md-icon>close</md-icon>
        </md-button>
      </md-field>
    </div>
  </filter-bar>
</template>
<script>
import FilterBar from "@/components/FilterBar";

export default {
  name: "RejectQuantificationReportFilters",
  components: {
    FilterBar,
  },
  data() {
    return {};
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.before-list-item {
  font-size: 1.6rem;
  padding: 8px 0px 8px 10px;
}
.before-list-item:hover {
  cursor: pointer !important;
  background-color: red;
  font-weight: bold;
  color: white;
}

.date-label {
  top: -9px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Reports/RejectedQuantification/Filter.vue